import { render, staticRenderFns } from "./ClinicUrls.vue?vue&type=template&id=ad137500&"
import script from "./ClinicUrls.vue?vue&type=script&lang=js&"
export * from "./ClinicUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports